import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorLoggingService } from './services/error-logging.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error: any) {
    super.handleError(error);

    // Sentry logging is disabled
    // If you want to re-enable Sentry:
    // 1. Uncomment the import: import * as Sentry from '@sentry/browser';
    // 2. Uncomment the Sentry.init() call in app.module.ts
    // 3. Uncomment the code below:
    //
    // try {
    //   if (environment.production) {
    //     Sentry.captureException(error.originalError || error);
    //   }
    // } catch (e) {
    //   console.error('Sentry error:', e);
    // }

    try {
      // Log to backend API
      // Use injector to avoid circular dependency issues
      const errorLoggingService = this.injector.get(ErrorLoggingService);
      errorLoggingService.logError(error).catch(err => {
        // Silently fail if error logging fails
        console.error('Failed to log error:', err);
      });
    } catch (e) {
      console.error('Error logging service error:', e);
    }
  }
}
